import * as Services from "../../../Service/Service"
import * as Url from '../../../Service/Url';
import axios from "axios";
import * as config from "../../config";

export const getDepartmentDetail = async() => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_DEPARTMENT_DATA, token)
  return res;
};

export const saveUserDetail = async(payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.SAVE_USER_DETAILS, payload, token)
  return res;
};

export const Signout = async(provider) => {
  const token = localStorage.getItem("token");
  let signout_url = provider === "Google" ? Url.SIGNOUT_GOOGLE_URL : Url.SIGNOUT_API_URL 
  let res = await Services.GET(signout_url, token)
  return res;
};
